import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

import * as docsTable from "@/styles/emotionStyles/docsTable";

export const heading = css({
  marginTop: "3rem",
  marginBottom: "1rem",

  "& > code": {
    fontSize: "inherit",
  },
});

export const subHeading = css({
  marginTop: "1.5rem",
  marginBottom: "0.75rem",
});

export const ul = css({
  paddingLeft: "1rem",
  marginLeft: "1.5rem",
  listStyle: "disc",
});

export const ol = css({
  paddingLeft: "1rem",
  marginLeft: "1.5rem",
  marginBottom: "1rem",
});

export const li = css({
  marginBlock: "1rem",
});

export const tableScrollWrapper = docsTable.scrollWrapper;

export const table = docsTable.table;

export const th = css(docsTable.cellText, {
  paddingTop: "0.25rem",
  paddingBottom: "0.25rem",
  paddingRight: "1rem",
  textAlign: "left",
  "&:first-child": {
    width: "1%",
    whiteSpace: "nowrap",
  },
});

export const td = css(docsTable.cellText, {
  paddingTop: "0.25rem",
  paddingBottom: "0.25rem",
  "&:first-child": {
    width: "1%",
    whiteSpace: "nowrap",
  },
  "&:not(:last-child)": {
    paddingRight: "1rem",
  },
  "& > code": {
    padding: "0.25rem 0.5rem",
    whiteSpace: "nowrap",
  },
});

export const strong = (theme: Theme) =>
  css({
    "&&": {
      color: theme.text.body,
      fontWeight: typography.weightSemiBold,
    },
  });
